export const getInvoiceStatus = (state) => state.status